import {environment} from "../environments/environment";

export function getImageURL(width, height, imageName): any {
    return `${environment.imageConfigs.serverPath}${environment.imageConfigs.imagePath.front}${width}/${height}/${environment.imageConfigs.imagePath.end}${imageName}`
}
